/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MTTutorialData
 */
export interface MTTutorialData {
    /**
     * 
     * @type {number}
     * @memberof MTTutorialData
     */
    period_length?: number;
    /**
     * 
     * @type {number}
     * @memberof MTTutorialData
     */
    cycle_length?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof MTTutorialData
     */
    previous_periods?: Array<number>;
}

/**
 * Check if a given object implements the MTTutorialData interface.
 */
export function instanceOfMTTutorialData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MTTutorialDataFromJSON(json: any): MTTutorialData {
    return MTTutorialDataFromJSONTyped(json, false);
}

export function MTTutorialDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): MTTutorialData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'period_length': !exists(json, 'period_length') ? undefined : json['period_length'],
        'cycle_length': !exists(json, 'cycle_length') ? undefined : json['cycle_length'],
        'previous_periods': !exists(json, 'previous_periods') ? undefined : json['previous_periods'],
    };
}

export function MTTutorialDataToJSON(value?: MTTutorialData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'period_length': value.period_length,
        'cycle_length': value.cycle_length,
        'previous_periods': value.previous_periods,
    };
}

